package tech.gensert.portal.common.model.config

enum class CookieNames {
    UserAccountId, Tokens, gt_login_hint, UserName, SSOToken
}